var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPieChart = function SvgPieChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.94 10.232.06.641a.183.183 0 0 1-.183.196l-8.728.022a.183.183 0 0 1-.181-.181V2.18a.18.18 0 0 1 .197-.18l.644.06a9.067 9.067 0 0 1 5.572 2.614 9.03 9.03 0 0 1 2.62 5.558Zm-10.077 1.905H20c.1 0 .182.082.182.182v.59a9.037 9.037 0 0 1-.716 3.541 9.05 9.05 0 0 1-1.947 2.889A9.056 9.056 0 0 1 11.09 22a9.035 9.035 0 0 1-3.541-.716 9.049 9.049 0 0 1-2.889-1.947A9.056 9.056 0 0 1 2 12.909a9.036 9.036 0 0 1 .716-3.54A9.05 9.05 0 0 1 4.664 6.48 9.056 9.056 0 0 1 11.09 3.82h.59c.1 0 .182.082.182.182v8.136Zm2.083 7.757a7.536 7.536 0 0 0 2.456-1.626 7.484 7.484 0 0 0 2.195-4.586h-8.28v-8.28a7.48 7.48 0 0 0-4.563 2.171 7.497 7.497 0 0 0-2.209 5.336c0 2.016.784 3.912 2.21 5.337a7.496 7.496 0 0 0 5.3 2.209 7.534 7.534 0 0 0 2.89-.56Z",
    fill: "#666"
  })));
};
export default SvgPieChart;